<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
        <div class="col-12">
            <div class="card">
            <div class="card-body">
                <b-button v-b-modal.modal-add variant="primary" class="btn btn-success rounded btn-sm"> <i class="mdi mdi-plus mr-1"></i> {{ $t('button.add.text') }}</b-button>
                <b-button-group>
                    <b-button @click="uploadFormat" variant="outline-secondary" class="btn btn-outline-success rounded btn-sm ml-1"> <i v-if="import_file == ''" class="mdi mdi-upload-multiple mr-1"></i> {{import_file != 0 ? import_file.name : 'Bulk Import'}}</b-button>
                    <b-button v-if="import_file != 0" @click="importCctv" variant="success" class="btn btn-success btn-sm">
                         <i v-if="loading" class="mdi mdi-spin mdi-loading"></i>
                         <i v-if="!loading" class="mdi mdi-upload-multiple"></i>
                    </b-button>
                </b-button-group>
                <input name="csv_cctv" type="file" ref="csv_cctv" class="d-none" v-on:change="bulkImport">
                <b-button @click="downloadFormat" title="Format CSV Bulk Import" variant="success" class="btn btn-sm rounded ml-1"> <i class="mdi mdi-arrow-collapse-down mr-1"></i> xlsx</b-button>
                
                <b-button @click="exportCCTV" variant="primary" class="btn rounded btn-sm ml-1"> <i class="mdi mdi-arrow-collapse-down mr-1"></i> Export Open CCTV</b-button>
                <b-modal
                    id="modal-add"
                    size="lg"
                    centered
                    :title="$t('button.add.text')"
                    title-class="font-18"
                    :ok-title="$t('button.save.text')"
                    :cancel-title="$t('button.cancel.text')"
                    @ok="addCctv"
                    @hidden="resetForm"
                >
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.name') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.name')"
                                v-model="form.cctv_name"
                                :class="{ 'is-invalid': submitted && $v.form.cctv_name.$error }"
                                />
                                <div v-if="submitted && $v.form.cctv_name.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.cctv_name.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.source') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.source')"
                                v-model="form.source"
                                :class="{ 'is-invalid': submitted && $v.form.source.$error }"
                                />
                                <div v-if="submitted && $v.form.source.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.source.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.category') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.category')"
                                v-model="form.category"
                                :class="{ 'is-invalid': submitted && $v.form.category.$error }"
                                />
                                <div v-if="submitted && $v.form.category.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.category.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.address') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.address')"
                                v-model="form.address"
                                :class="{ 'is-invalid': submitted && $v.form.address.$error }"
                                />
                                <div v-if="submitted && $v.form.address.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.address.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.district') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.district')"
                                v-model="form.district"
                                :class="{ 'is-invalid': submitted && $v.form.district.$error }"
                                />
                                <div v-if="submitted && $v.form.district.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.district.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.sub-district') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.sub-district')"
                                v-model="form.sub_district"
                                :class="{ 'is-invalid': submitted && $v.form.sub_district.$error }"
                                />
                                <div v-if="submitted && $v.form.sub_district.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.sub_district.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom02">{{ $t('form.open-cctv.label.link') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.link')"
                                v-model="form.link"
                                :class="{ 'is-invalid': submitted && $v.form.link.$error }"
                                />
                                <div v-if="submitted && $v.form.link.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.link.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.coordinate') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.open-cctv.placeholder.coordinate')"
                                v-model="form.coordinate"
                                :class="{ 'is-invalid': submitted && $v.form.coordinate.$error }"
                                />
                                <div v-if="submitted && $v.form.coordinate.$error " class="invalid-feedback">
                                    <span v-if="!$v.form.coordinate.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.open-cctv.label.status') }}</label>
                                <select 
                                class="custom-select" 
                                v-model="form.status" 
                                :class="{ 'is-invalid': submitted && ($v.form.status.$error || form.status == $t('form.open-cctv.placeholder.status'))}">
                                    <option selected>{{ $t('form.open-cctv.placeholder.status') }}</option>
                                    <option value="on">On</option>
                                    <option value="off">Off</option>
                                </select>
                                <div v-if="submitted && $v.form.status.$error || form.status == $t('form.open-cctv.placeholder.status')" class="invalid-feedback">
                                    <span>{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-modal>
                <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Show&nbsp;&nbsp;
                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;&nbsp;entries
                    </label>
                    </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                        ></b-form-input>
                    </label>
                    </div>
                </div>
                <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                <b-table
                    :items="tableData"
                    :fields="fields"
                    bordered striped
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                >
                    <template #cell(status)="row">  
                    <span :class="row.item.status == 'on' ? 'badge-success' : 'badge-danger' " class="badge rounded p-1 px-1 text-white text-md"> {{row.item.status}}</span>
                    </template>

                    <template #cell(actions)="row">
                        <router-link :to="{ name: 'detail-cctv', params: { id: row.item.id_cctv }}">
                            <b-button class="mr-1 btn-sm" variant="primary" > 
                                <i class="px-1 fas fa-info"></i>
                            </b-button>
                        </router-link>
                        <b-button class="mr-1 btn-sm" variant="info" @click="editCctv(row.item)"> 
                             <i class="bx bx-pencil"></i> 
                        </b-button>
                        <b-modal
                            :id="'modal-edit'+row.item.id_cctv"
                            size="lg"
                            centered
                            :title="$t('button.update.text')"
                            title-class="font-18"
                            :ok-title="$t('button.update.text')"
                            :cancel-title="$t('button.cancel.text')"
                            @ok="updateCctv($event, row.item.id_cctv)"
                            @hidden="resetForm"
                        >
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.name') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.name')"
                                        v-model="form.cctv_name"
                                        :class="{ 'is-invalid': submitted && $v.form.cctv_name.$error }"
                                        />
                                        <div v-if="submitted && $v.form.cctv_name.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.cctv_name.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.source') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.source')"
                                        v-model="form.source"
                                        :class="{ 'is-invalid': submitted && $v.form.source.$error }"
                                        />
                                        <div v-if="submitted && $v.form.source.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.source.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.category') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.category')"
                                        v-model="form.category"
                                        :class="{ 'is-invalid': submitted && $v.form.category.$error }"
                                        />
                                        <div v-if="submitted && $v.form.category.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.category.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.address') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.address')"
                                        v-model="form.address"
                                        :class="{ 'is-invalid': submitted && $v.form.address.$error }"
                                        />
                                        <div v-if="submitted && $v.form.address.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.address.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.district') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.district')"
                                        v-model="form.district"
                                        :class="{ 'is-invalid': submitted && $v.form.district.$error }"
                                        />
                                        <div v-if="submitted && $v.form.district.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.district.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.sub-district') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.sub-district')"
                                        v-model="form.sub_district"
                                        :class="{ 'is-invalid': submitted && $v.form.sub_district.$error }"
                                        />
                                        <div v-if="submitted && $v.form.sub_district.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.sub_district.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom02">{{ $t('form.open-cctv.label.link') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.link')"
                                        v-model="form.link"
                                        :class="{ 'is-invalid': submitted && $v.form.link.$error }"
                                        />
                                        <div v-if="submitted && $v.form.link.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.link.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.coordinate') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.open-cctv.placeholder.coordinate')"
                                        v-model="form.coordinate"
                                        :class="{ 'is-invalid': submitted && $v.form.coordinate.$error }"
                                        />
                                        <div v-if="submitted && $v.form.coordinate.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.coordinate.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.open-cctv.label.status') }}</label>
                                        <select 
                                        class="custom-select" 
                                        v-model="form.status" 
                                        :class="{ 'is-invalid': submitted && $v.form.status.$error }">
                                            <option selected>{{ $t('form.open-cctv.placeholder.status') }}</option>
                                            <option value="on">On</option>
                                            <option value="off">Off</option>
                                        </select>
                                        <div v-if="submitted && $v.form.status.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.status.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                        <b-button class="mr-2 btn-sm" variant="danger" @click="deleteCctv(row.item.id_cctv)">
                        <i class="bx bx-trash"></i>
                        </b-button>
                    </template>
                </b-table>
                </div>
                <div class="row" v-if="rows > 10">
                    <div class="col-2 col-xl-1">
                        <!-- <div v-if="selected[0]">
                        <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                        </div> -->
                        <label class="d-inline-flex align-items-center">
                        Page
                        <b-form-input
                            v-model="currentPage"
                            placeholder="Page"
                            class="form-control w-10 form-control ml-2"
                        ></b-form-input>
                        </label>
                    </div>
                    <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                    </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import CctvService from "@/helpers/cctv.service"
import { tableData } from '../personal/dataAdvancedtable';

export default {
    page: {
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            tableData: [],
            title: this.$t('menuitems.cctv.text'),
            items: [
                {
                text: this.$t('menuitems.setting.text'),
                href: "#"
                },
                {
                text: this.$t('menuitems.cctv.text'),
                active: true
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "total_profile",
            sortDesc: false,
            fields: [
                { key: "no", class: 'text-center', thStyle: { width: "3%" }, label:'No'},
                { key: "cctv_name", sortable: true, label: this.$t('table.open-cctv.th.name') },
                { key: "source", sortable: true, label: this.$t('table.open-cctv.th.source') },
                { key: "category", sortable: true, label: this.$t('table.open-cctv.th.category') },
                { key: "district", sortable: true, label: this.$t('table.open-cctv.th.district') },
                { key: "status", class: 'text-center', label: this.$t('table.open-cctv.th.status') },
                { key: 'actions', class: 'text-center', label: this.$t('table.open-cctv.th.action') }
            ],
            form: {
                cctv_name: "",
                source: "",
                category: "",
                address: "",
                district: "",
                sub_district: "",
                link: "",
                coordinate: "",
                status: this.$t('form.open-cctv.placeholder.status')
            },
            submitted: false,
            import_file : "",
            loading: false
        };
    },
    validations: {
        form: {
            cctv_name: { required },
            source: { required },
            category: { required },
            address: { required },
            district: { required },
            sub_district: { required },
            link: { required },
            coordinate: { required },
            status: { required }
        },
    },
    computed: {
        rows() {
        return this.tableData.length;
        }
    },
    methods: {
        getCctv(){
            CctvService.list()
            .then(response => {
                this.tableData = []
                response.data.data.forEach((val, index) => {
                    const data = {
                    "no" : index+1,
                    "id_cctv" : val.id,
                    "cctv_name" : val.cctv_name,
                    "source" : val.source,
                    "category" : val.category,
                    "district" : val.district,
                    "sub_district" : val.sub_district,
                    "address" : val.address,
                    "link" : val.link,
                    "coordinate" : val.coordinate,
                    "status" : val.status,
                    }
                    this.tableData.push(data);
                });
            })
            .catch(err => {
                console.log(err);
            });
        },
        addCctv(e) {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.form.$invalid) {
                e.preventDefault();
            }else{
                const data = {
                    'cctv_name' : this.form.cctv_name,
                    'source' : this.form.source,
                    'category' : this.form.category,
                    'address' : this.form.address,
                    'district' : this.form.district,
                    'sub_district' : this.form.district,
                    'link' : this.form.link,
                    'coordinate' : this.form.coordinate,
                    'status' : this.form.status,
                }

                CctvService.create(data)
                .then( response => {
                    this.getCctv();
                    Vue.swal({
                        position: "top-end",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.$v.$reset();
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        editCctv(data){
            this.$bvModal.show('modal-edit'+data.id_cctv);
            this.form.cctv_name = data.cctv_name;
            this.form.source = data.source;
            this.form.category = data.category;
            this.form.address = data.address;
            this.form.district = data.district;
            this.form.sub_district = data.sub_district;
            this.form.link = data.link;
            this.form.coordinate = data.coordinate;
            this.form.status = data.status;
        },
        updateCctv(e, id){
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.form.$invalid) {
                e.preventDefault();
            }else{
                const data = {
                    'cctv_name' : this.form.cctv_name,
                    'source' : this.form.source,
                    'category' : this.form.category,
                    'address' : this.form.address,
                    'district' : this.form.district,
                    'sub_district' : this.form.district,
                    'link' : this.form.link,
                    'coordinate' : this.form.coordinate,
                    'status' : this.form.status,
                }

                CctvService.update(id, data)
                .then( response => {
                    this.getCctv();
                    Vue.swal({
                        position: "top-end",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.$v.$reset();
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        deleteCctv(id){
            Swal.fire({
                title: this.$t('button.delete.modal.confirmText[0]'),
                text: this.$t('button.delete.modal.confirmText[1]'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: this.$t('button.cancel.text'),
                confirmButtonText: this.$t('button.delete.text')
            }).then((result) => {
                if (result.isConfirmed) {
                    CctvService.delete(id)
                    .then( response => {
                        this.getCctv();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( err => {
                        console.log(err);
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onDelete(id){
            console.log('delete data:', id);
        },
        onView(id){
            console.log('details data:', id);
        },
        resetForm(){
            setTimeout(()=>{
                this.form.cctv_name = '';
                this.form.source = '';
                this.form.category = '';
                this.form.address = '';
                this.form.district = '';
                this.form.sub_district = '';
                this.form.link = '';
                this.form.coordinate = '';
                this.form.status = this.$t('form.open-cctv.placeholder.status');
                this.submitted = false;
                this.$v.form.$reset();
            }, 1000)
        },
        downloadFormat(){
            CctvService.format()
            .then(response => {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'format_import_cctv.xlsx');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            });
        },
        exportCCTV(){
            console.log('export');
            CctvService.export()
            .then(response => {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'opencctv.xlsx');
                document.body.appendChild(fileLink);
            
                fileLink.click();
            });
        },
        uploadFormat(){
            this.$refs.csv_cctv.click();
        },
        bulkImport(){
            this.import_file = this.$refs.csv_cctv.files[0];
        },
        importCctv(){
            this.loading = true;
            let formData = new FormData();
            formData.append('csv_cctv', this.import_file);
            CctvService.import(formData)
            .then(response => {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$refs.csv_cctv.value = '';
                this.import_file = ''
                this.loading = false;
                this.getCctv();
            })
            .catch(e => {
                Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: e.response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                this.$refs.csv_cctv.value = '';
                this.loading = false;
                this.getCctv();
            });
        },
    },
    mounted() {
        this.totalRows = this.items.length;
        this.getCctv();
    },
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
</style>